import React from 'react'

import './ChartHeader.css'

const ChartHeader = ({ title }) => {
  return (
    <div className="chat-header">
      <p className="title">{title}</p>

      {/* <div className="export-btn">
        <p>Exportar relatório</p>
      </div> */}
    </div>
  )
}

export default ChartHeader
